let flag ='';
if (window.location.hostname == "localhost") {
  window.HTTP_ROOT_PATH = "https://maha-tp.hoja-crm.com/";
//   http://dev22.hoja-crm.com/
  flag = "testLogIn=1&";
  window.HTTP_ROOT_PATH_IMAGE = ""
} else {
  window.HTTP_ROOT_PATH = "https://" + window.location.hostname + "/";
  window.HTTP_ROOT_PATH_IMAGE = "https://" + window.location.hostname + "/";
  flag = "";
}
window.API_DASHBOARD_IMAGE= window.HTTP_ROOT_PATH_IMAGE+ "/businessDashboard" ;
window.API_DASHBOARD_DATA = window.HTTP_ROOT_PATH + `getData.php?${flag}`;
let domain = window.API_DASHBOARD_DATA;
let imageDomain = window.API_DASHBOARD_IMAGE
